import React from 'react';
import { motion } from 'framer-motion';
import { Container } from './ui/Container';
import { SectionTag } from './ui/SectionTag';
import { PlaceholderMockup } from './ui/PlaceholderMockup';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
interface PremiumItemProps {
  label: string;
  title: string;
  tag: string;
  copy: string[];
  bigLine: string;
  smallNote?: string | string[];
  imageLabel: string;
  imageUrl?: string;
  reverse?: boolean;
}
export function PremiumItem({
  label,
  title,
  tag,
  copy,
  bigLine,
  smallNote,
  imageLabel,
  imageUrl,
  reverse = false
}: PremiumItemProps) {
  const noteLines = typeof smallNote === 'string' ? [smallNote] : smallNote;
  return <section className="bg-mp-dark py-20 md:py-24" data-id="element-247" data-mp="3mq9ywei527yg">
      <Container data-id="element-248" data-mp="162fjf0ft2pgw">
        <div className={`flex flex-col gap-10 md:gap-14 ${reverse ? 'md:flex-row-reverse' : 'md:flex-row'} items-center`} data-id="element-249" data-mp="161wcsfvlvni6">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5,
          ease: easeOut
        }} className="w-full md:w-[46%]" data-id="element-250" data-mp="1202gejsg15nt">
            <PlaceholderMockup label={imageLabel} aspect="aspect-[4/3]" className="border-mp-electric/40" src={imageUrl} alt={imageLabel} width={800} height={600} data-id="element-251" data-mp="2isc1s891trx7" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5,
          ease: easeOut,
          delay: 0.05
        }} className="w-full md:w-[54%]" data-id="element-252" data-mp="1v27zq5bie08b">
            <SectionTag tone="blue" data-id="element-253" data-mp="17dyjdix2e4ok">{label}</SectionTag>
            <h3 className="mt-4 font-heading text-2xl uppercase leading-snug text-mp-white sm:text-3xl" data-id="element-254" data-mp="17bcczmlwtv7x">{title}</h3>
            <p className="mt-1 font-heading text-xs uppercase tracking-[0.18em] text-mp-lime" data-id="element-255" data-mp="2fnfijo117sfb">{tag}</p>

            <div className="mt-4 max-w-[560px] space-y-3 text-sm leading-relaxed text-mp-gray md:text-base" data-id="element-256" data-mp="2aocarvto383n">
              {copy.map((p, idx) => <p key={idx} data-id="element-257" data-mp="2oefuaf15wnpe" data-mpi={idx}>{p}</p>)}
            </div>

            <p className="mt-6 font-heading text-2xl uppercase leading-tight text-mp-white sm:text-3xl" data-id="element-258" data-mp="2kdm6rmrmtax1">{bigLine}</p>

            {noteLines && <div className="mt-3 space-y-1 text-sm text-mp-gray" data-id="element-259" data-mp="1wotfw4pv9t9a">
                {noteLines.map((line, idx) => <p key={idx} data-id="element-260" data-mp="1rrtazx4r6wjr" data-mpi={idx}>{line}</p>)}
              </div>}
          </motion.div>
        </div>
      </Container>
    </section>;
}